import { Empty } from 'antd'
import { PropsWithChildren } from 'react'

import { Note } from '@types'

import { NoteElement } from '../../../NoteElement'
import InfoSection from '../components/InfoSection'

interface ObservationsSectionProps {
  observations: Note[]
}

const ObservationsSection: React.FC<PropsWithChildren<ObservationsSectionProps>> = ({
  observations,
  children,
}) => (
  <InfoSection header="Comentarios">
    {observations?.length ? (
      <>
        {observations.map((observation: Note) => (
          <NoteElement data={observation} />
        ))}
      </>
    ) : (
      <Empty />
    )}
    {children}
  </InfoSection>
)

export default ObservationsSection
